import React from "react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-white py-16" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
        <p className="text-xs uppercase tracking-[0.2em] text-[#00C853] font-semibold">Legal</p>
        <h1 className="font-display text-4xl font-bold text-[#0B3C5D] tracking-tight">Terms of Service</h1>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString()}</p>

        <h2 className="font-display text-[#0B3C5D]">1. Acceptance of Terms</h2>
        <p>By creating an account or using Giftopay, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, do not use the platform.</p>

        <h2 className="font-display text-[#0B3C5D]">2. Eligibility</h2>
        <p>You must be at least 18 years old and reside in a supported country (United States, United Kingdom, United Arab Emirates, or Canada) to use Giftopay.</p>

        <h2 className="font-display text-[#0B3C5D]">3. Account Registration</h2>
        <p>You agree to provide accurate and complete information when registering. You are responsible for all activity that occurs under your account.</p>

        <h2 className="font-display text-[#0B3C5D]">4. Gift Card Submissions</h2>
        <p>By submitting a gift card, you warrant that:</p>
        <ul>
          <li>You are the lawful owner of the card.</li>
          <li>The card has not been reported lost, stolen, or fraudulent.</li>
          <li>The balance and condition are accurately represented.</li>
        </ul>
        <p>Submission of fraudulent cards may result in immediate account termination and reporting to relevant authorities.</p>

        <h2 className="font-display text-[#0B3C5D]">5. Rates & Payouts</h2>
        <p>Exchange rates are determined by market conditions and may vary by brand, country, and card condition. Once you submit a transaction, your rate is locked for 5 minutes. Payouts are made via the method you select; processing times are estimates and may vary.</p>

        <h2 className="font-display text-[#0B3C5D]">6. Fees</h2>
        <p>Giftopay charges a 2% platform processing fee deducted from the gross payout. Additional network fees may apply for cryptocurrency payouts.</p>

        <h2 className="font-display text-[#0B3C5D]">7. Fraud Prevention</h2>
        <p>We employ AI-driven fraud detection, including duplicate card checks, velocity analysis, device fingerprinting, and IP risk scoring. Suspicious activity may delay or cancel payouts.</p>

        <h2 className="font-display text-[#0B3C5D]">8. Prohibited Conduct</h2>
        <p>You may not submit cards obtained through fraud, theft, or chargeback abuse; create multiple accounts; or attempt to circumvent our security systems.</p>

        <h2 className="font-display text-[#0B3C5D]">9. Limitation of Liability</h2>
        <p>Giftopay is provided &quot;as is&quot;. To the maximum extent permitted by law, Giftopay shall not be liable for any indirect, incidental, or consequential damages.</p>

        <h2 className="font-display text-[#0B3C5D]">10. Termination</h2>
        <p>We reserve the right to suspend or terminate accounts that violate these Terms or pose a risk to the platform.</p>

        <h2 className="font-display text-[#0B3C5D]">11. Governing Law</h2>
        <p>These Terms are governed by the laws applicable in your country of residence among the supported jurisdictions.</p>

        <h2 className="font-display text-[#0B3C5D]">12. Contact</h2>
        <p>For questions, contact <a className="text-[#00C853]" href="mailto:support@giftopay.com">support@giftopay.com</a>.</p>
      </div>
    </div>
  );
}
